// 错误日志模块状态
const state = {
    // 错误日志
    logs: []
};

// 错误日志模块mutations
const mutations = {
    /**
     * 添加错误日志
     */
    addErrorLog(state, value) {
        state.logs.push(value);
    },
    /**
     * 清空错误日志
     */
    clearErrorLog(state) {
        state.logs.splice(0);
    }
};

export default {
    namespaced: true,
    state,
    mutations
};
